import type { DesignKitSection, WorkspaceSurfaceId } from '@/features/workspace/navigation/types';

export const WORKSPACE_TAB_QUERY_KEY = 'tab';
export const DESIGN_KIT_SECTION_QUERY_KEY = 'designKit';

const WORKSPACE_SURFACES = new Set<WorkspaceSurfaceId>([
    'newchat',
    'projects',
    'connectors',
    'experts',
    'design-kit',
    'infra',
]);

/** 只接受已注册的 Workspace 顶层 Surface。 */
export function isWorkspaceSurfaceId(value: string | null): value is WorkspaceSurfaceId {
    return value !== null && WORKSPACE_SURFACES.has(value as WorkspaceSurfaceId);
}

/** 非法或已下线的 tab 一律回到 New Project，不保留 alias。 */
export function resolveWorkspaceSurface(value: string | null): WorkspaceSurfaceId {
    return isWorkspaceSurfaceId(value) ? value : 'newchat';
}

/** 解析 Design Kit 内部列表状态，非法值回到首页。 */
export function resolveDesignKitSection(value: string | null): DesignKitSection {
    return value === 'templates' || value === 'components' ? value : 'home';
}
